import React from 'react';
import { AssignmentListPageContainer } from 'containers';
import './style.scss';

function AssignmentListPage() {
  return (
    <div className="tv-assignment-list__container">
      <div className="tv-assignment-list__wrapper">
        <AssignmentListPageContainer />
      </div>
    </div>
  );
}

AssignmentListPage.propTypes = {};

export default AssignmentListPage;
